module.exports = __webpack_public_path__ + "img/beauty-bg.129048dc.png";